import axios from 'axios';

const API_BASE_URL = 'https://experiment-grxi.onrender.com/api/employees';

const employeeService = {
  getAllEmployees: () => axios.get(API_BASE_URL),
  getEmployeeById: (id) => axios.get(`${API_BASE_URL}/${id}`),
  createEmployee: (employee) => axios.post(API_BASE_URL, employee),
  updateEmployee: (id, employee) => axios.put(`${API_BASE_URL}/${id}`, employee),
  deleteEmployee: (id) => axios.delete(`${API_BASE_URL}/${id}`),
  getEmployeesByDepartment: (department) => axios.get(`${API_BASE_URL}/department/${department}`),
  getActiveEmployees: () => axios.get(`${API_BASE_URL}/active`),
  getEmployeesBySalaryRange: (minSalary, maxSalary) => 
    axios.get(`${API_BASE_URL}/salary-range?minSalary=${minSalary}&maxSalary=${maxSalary}`),
  searchEmployees: (lastName) => axios.get(`${API_BASE_URL}/search?lastName=${lastName}`),
  getDepartmentCount: (department) => axios.get(`${API_BASE_URL}/department/${department}/count`)
};

export default employeeService;